<template>
  <div style="position: relative;">
    <el-form ref="specialistFilter" :model="specialist" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="名称" prop="formFilter.showName">
          <el-input class="filter-item" v-model="specialist.formFilter.showName"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="类型" prop="formFilter.mobileUserType">
          <el-select v-model="specialist.formFilter.mobileUserType" placeholder="请选择">
            <el-option label="特派员" :value="3"> </el-option>
            <el-option label="联络员" :value="4"> </el-option>
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize"
                   @click="getTemplateRow">选择</el-button>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="refreshSpecialist(true)">查询</el-button>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetSpecialist">重置</el-button>

      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="specialist" :data="specialist.Specialist.impl.dataList" :size="defaultFormItemSize" @sort-change="specialist.Specialist.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
                  highlight-current-row @current-change="specialist.Specialist.impl.currentRowChange"
                  @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="specialist.Specialist.impl.getTableIndex" />
          <el-table-column label="名称" prop="showName">
          </el-table-column>
          <el-table-column label="类型" >
            <template slot-scope="scope">
              <p v-if="scope.row.mobileUserType ===3">特派员</p>
              <p v-if="scope.row.mobileUserType ===4">联络员</p>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="specialist.Specialist.impl.totalCount"
            :current-page="specialist.Specialist.impl.currentPage"
            :page-size="specialist.Specialist.impl.pageSize"
            :page-sizes="[10, 20, 50, 100,500]"
            layout="total, prev, pager, next, sizes"
            @current-change="specialist.Specialist.impl.onCurrentPageChange"
            @size-change="specialist.Specialist.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
  import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
  import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
  import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
  import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
  import { SysUserController, DictionaryController } from '@/api';

export default {
  name: 'selectUser',
  props: {
    selectUserId: {
      type: Object
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      hotFlag: true,
      value: '1',
      specialist: {
        formFilter: {
          showName: undefined,
          mobileUserType: undefined
        },
        formFilterCopy: {
          showName: undefined,
          mobileUserType: undefined
        },
        Specialist: {
          impl: new TableWidget(this.loadSpecialistWidgetData, this.loadSpecialistVerify, true, true, 'createTime', 1)
        },
        isInit: false,
        multipleSelection: [],
        userInfo: {}
      }
    }
  },
  methods: {

    // 选择后回调
    getTemplateRow () {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.error('请选择人员');
        return;
      }
      let idList = []
      let nameList = []
      this.multipleSelection.forEach((item) => {
        idList.push(item.id)
        nameList.push(item.name)
      })
      let param = {idList: idList, nameList: nameList, multipleSelection: this.multipleSelection}
      // console.log(param)
      this.onCancel(true, param);
    },
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    onResetSpecialist () {
      this.$refs.specialistFilter.resetFields();
      this.refreshSpecialist(true);
    },
    /**
       * 专家主表数据获取函数，返回Promise
       */
    loadSpecialistWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        filter: {
          showName: this.specialist.formFilter.showName,
          mobileUserType: this.specialist.formFilter.mobileUserType
        },
        selectUserId: this.selectUserId
      }
      if (this.userInfo.isSpecial === '2') {
        params.filter.deptId = 1
      }
      return new Promise((resolve, reject) => {
        SysUserController.listWork(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.specialist.Specialist.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.specialist.Specialist.impl.currentRow.id, 'id');
              this.$refs.specialist.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange (val) {
      // console.log(val)
      this.multipleSelection = val;
    },
    /**
       * 专家主表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
       */
    loadSpecialistVerify () {
      return true;
    },

    /**
       * 类型选中值改变
       */
    onSpecialistTypeValueChange (value) {
    },
    /**
       * 是否委派下拉数据获取函数
       */
    loadAppointFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 是否委派选中值改变
       */
    onAppointFlagValueChange (value) {
    },
    /**
       * 更新专家管理
       */
    refreshSpecialist (reloadData = false) {
      if (reloadData) {
        this.specialist.Specialist.impl.refreshTable(true, 1);
      } else {
        this.specialist.Specialist.impl.refreshTable();
      }
      if (!this.specialist.isInit) {
        // 初始化下拉数据
      }
      this.specialist.isInit = true;
    },
    onResume () {
      this.refreshSpecialist();
    },
    initFormData () {
    },
    formInit () {
      this.refreshSpecialist();
    }
  },
  mounted () {
    this.userInfo = this.$store.state.userInfo

    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
